document.querySelector('.skip-to-content')?.addEventListener('click', function (event) {
  const main = document.getElementById('main');
  if (!main) return;
  event.preventDefault();
  event.stopPropagation();
  main.focus({ preventScroll: true });
  main.scrollIntoView({ block: 'start', behavior: 'instant' });
});
window.addEventListener('pageshow', function () {
  document.body.getAnimations().forEach(function (animation) {
    if (animation.effect?.getKeyframes().some(function (frame) { return frame.opacity === '0'; })) animation.cancel();
  });
});
